/***
 * Access Token & User Cookies
 * @type {string}
 */
const cookieAuth = "session"
const cookieData = "user"
const cookieRefresh = "refresh"
const renterApplicationId = "renterApplicationId"
export {cookieData,cookieAuth,cookieRefresh,renterApplicationId}